import type { UUID } from '@/types/common'
import type { CreateVehicleRequest, UpdateVehicleRequest, Vehicle, VehiclesResponse } from '@/types/vehicle'

import { api } from './client'

export interface GetVehiclesParams {
  number?: string;
  model?: string;
  makeFrom?: number;
  makeTo?: number;
  createdAfter?: string;
  createdBefore?: string;
  page?: number;
  limit?: number;
  sort?: string[];
}

export const vehiclesApi = {
  getVehicles: (params?: GetVehiclesParams) =>
    api.get<VehiclesResponse>('/vehicles', params),

  createVehicle: (data: CreateVehicleRequest) =>
    api.post<Vehicle>('/vehicles', data),

  getVehicle: (id: UUID) =>
    api.get<Vehicle>(`/vehicles/${id}`),

  updateVehicle: (id: UUID, data: UpdateVehicleRequest) =>
    api.put<Vehicle>(`/vehicles/${id}`, data),

  deleteVehicle: (id: UUID) =>
    api.delete<void>(`/vehicles/${id}`),
}
